import React, { useState } from 'react'

const CustomTab = ({ tabArray = [], tabWidth = "100px", components = [] }) => {

    const [activeTab, setActiveTab] = useState(0)

    return (
        <div>
            <div className='tabHeader'>
                {
                    tabArray.map((tab, idx) => {
                        return <button
                            className={activeTab === idx ? "active" : ""}
                            style={{ width: tabWidth }}
                            onClick={() => setActiveTab(idx)}
                            key={tab.label}
                        >
                            {tab.icon} {tab.label}
                        </button>
                    })
                }
            </div>
            <div className='tabBody'>
                {
                    components[activeTab]
                }
            </div>
        </div>
    )
}

export default CustomTab